<template>
  <el-container id="dataShow">
    <!--    <el-header style="height:38px;line-height:30px;padding:0;margin:0;background:#F4F4F4">-->
    <!--      <div style="display:flex;white-space: nowrap;">-->
    <!--        <p v-for="l in li_h_text" :style="{color:l.colour,lineHeight:0.3}">{{ l.text }} > </p>-->
    <!--        <p style="color:#000000;line-height:0.3;margin-left:5px">{{ h_text }}</p>-->
    <!--      </div>-->
    <!--    </el-header>-->
    <el-container class="div_main">

    </el-container>
  </el-container>
</template>

<script>
export default {
  name:"dataShow",
  components:{ /*引入组件*/

  },
  data() {
    return {
      h_text:"数据看板",
      li_h_text:[
        {"text":"会所管理","colour":"#B7B7B7","pages":""}
      ]
    };
  },
  methods:{ /*方法存放*/

  },
  mounted() { /*页面加载时调用*/

  },
  beforeDestroy() { /*页面结束时调用*/

  }
};
</script>

<style>

#dataShow {
  height: 100vh;
  margin: 0;
  padding-left: 16px;
  padding-right: 16px;
  padding-top: 16px;
  background: #F4F4F4;
}

.div_main {
  background: #FFFFFF;
  height: auto;
  margin-bottom: 60px;
  border-radius: 5px 5px 5px 5px;
}
</style>



// WEBPACK FOOTER //
// src/pages/hs/dataShow.vue